// =============================================================
// 参数→步骤关键字映射表
// 把"参数 id"映射到对应的"建议步骤关键字"，用于自动判定调参动作命中了哪个步骤
// 每个故障的 correct steps action 文本里若包含其中任一关键字，则视为对应。
//
// 从 drillStore.ts 外置到此处，使 drillStore 不再承载场景特定配置。
// 部分参数（如 rpm/temp/pressure）跨场景共用，因此保持扁平结构。
// =============================================================

export const PARAM_TO_STEP_KEYWORDS: Record<string, string[]> = {
  // FCC 场景
  reactor_temp: ['反应温度', '急冷油', '反应器'],
  regenerator_temp: ['再生温度', '再生器'],
  air_flow: ['风量', '主风', '过滤器'],
  regenerator_pressure: ['再生压力', '催化剂循环'],
  tower_top_temp: ['塔顶温度', '回流'],
  tower_top_pressure: ['塔顶压力', '吹汽'],
  catalyst_circulation: ['催化剂循环', '滑阀'],
  valve_opening: ['滑阀', '塞阀'],
  pump_flow: ['流量'],

  // 阳极振压成型场景
  paste_temp:     ['糊料温度', '糊料', '保温', '升温'],
  pitch_ratio:    ['沥青', '配比'],
  mixer_speed:    ['搅拌'],
  mold_temp:      ['模具温度', '模具'],
  mold_pre_temp:  ['模具预热', '预热', '加热'],
  heat_power:     ['加热功率', '加热站', '功率'],
  press_force:    ['振压压力', '压力', '振压'],
  press_time:     ['振压时间', '时间', '振压'],
  vib_freq:       ['振动频率', '频率', '振动'],
  vac_pressure:   ['真空', '绝压', '抽气'],
  vac_flow:       ['抽气流量', '真空', '抽气'],
  feed_weight:    ['加料量', '称量'],
  coke_ratio:     ['石油焦', '粒度', '配比'],
  fine_ratio:     ['细粒', '配比'],
  cool_speed:     ['冷却', '传送速度'],

  // 阳极焙烧炉场景
  room_temp:      ['炉室温度', '炉室', '温度'],
  flue_temp_l:    ['左火道', '左火', '火道'],
  flue_temp_r:    ['右火道', '右火', '火道'],
  gas_flow:       ['燃料气', '燃料', '流量'],
  gas_pressure:   ['燃料气压力', '气压', '压力'],
  fan_speed:      ['抽烟机', '转速', '抽烟'],
  fan_current:    ['电机电流', '电流'],
  suction_flow:   ['抽气流量', '抽气', '抽烟'],
  flue_pressure:  ['烟道负压', '负压', '烟道'],
  inlet_dust:     ['含尘', '净化'],
  coke_level:     ['焦床料位', '焦床', '焦炭'],
  coke_thickness: ['焦床厚度', '焦床'],

  // TBM 盾构机场景
  rpm:            ['刀盘转速', '转速', '降低刀盘'],
  torque:         ['刀盘扭矩', '扭矩'],
  wear:           ['刀具磨损', '磨损', '换刀'],
  temp:           ['刀具温度', '温度'],
  speed:          ['推进速度', '推进', '降低推进'],
  thrust:         ['总推力', '推力', '油缸'],
  roll:           ['滚动角', '纠偏', '千斤顶'],
  pressure:       ['仓压', '泥浆', '泥水仓压', '保压'],
  density:        ['泥浆密度', '密度', '水泥浆密度'],
  screw_rpm:      ['螺旋转速', '螺旋'],
  inject_volume:  ['注浆量', '注浆', '同步注浆'],
  inject_pressure:['注浆压力', '注浆'],
  seal_pressure:  ['密封压力', '盾尾密封', '密封'],
  x_deviation:    ['水平偏差', 'X', '姿态'],
  y_deviation:    ['垂直偏差', 'Y', '姿态'],
  precision:      ['拼装精度', '拼装'],
  vibration:      ['振动', '主驱动'],

  // 海上钻井平台场景（rpm/torque/temp/pressure/vibration 已在 TBM 段定义，此处仅补充 offshore 专属参数）
  hoist_load:    ['大钩载荷', '钻具', '活动钻具'],
  wob:           ['钻压', '降低钻压'],
  hoist_speed:   ['提升速度', '提拉'],
  flow_rate:     ['泥浆泵流量', '泥浆', '流量', '排量', '循环'],
  stroke:         ['冲次', '泥浆泵'],
  annular_pressure: ['环空压力', '环空', '背压', '节流'],
  ram_status:     ['闸板密封', 'BOP', '防喷器'],
  control_pressure: ['控制液压', '液压'],
  derrick_load:  ['井架载荷', '井架'],
  wind_speed:     ['风载', '风速', '风'],
  tension:        ['张力', '隔水管'],
  mud_return:     ['泥浆返出', '返出', '泥浆'],
  angle:          ['偏角', '隔水管'],
  cement_pressure: ['固井泵压', '固井'],
  cement_flow:    ['固井流量', '固井'],
  choke_pressure: ['节流压力', '节流', '关节流'],
  kill_flow:      ['压井流量', '压井'],
  valve_pos:      ['节流阀开度', '节流阀'],
  throughput:     ['处理量', '振动筛'],
  mesh_status:    ['筛网完好度', '筛网'],
  flare_rate:     ['燃烧量', '火炬'],
  flare_temp:     ['火焰温度', '火炬'],
  power:          ['输出功率', '发电机'],
  voltage:        ['电压', '发电机'],
  frequency:      ['频率', '发电机'],
  wind_deck:      ['甲板风速', '甲板', '风速'],
  visibility:     ['能见度', '直升机'],
};
